import axiosInstance from "./axios-instance";

const approve = (payload, file) => {
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    if (file) formData.append("file", file);

    return axiosInstance.post("/app/referral-engagements/approve", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 120000,
    }).then(res => res);
};

export default { approve };
